





















































































































import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class MemberBody extends Vue {
  @Prop() readonly data: any;

  @Prop() readonly total: any;

  @Prop() readonly gameType!: string;

  @Prop() readonly provider!: string;

  @Prop() readonly footer: any;

  @Prop() readonly currentState!: string;

  @Prop() readonly handleSub!: Function;

  utilsInstance = utils;

  setContentInTable(currentState, item) {
    if (currentState === 'provider') return item.game;
    if (currentState === 'type') return this.provider;
    if (currentState === 'game') return item.gameName.en.toUpperCase();
    return 'amb';
  }
}
